import { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Gallery from './pages/Gallery';
import Appointment from './pages/Appointment';
import Contact from './pages/Contact';
import BookingPopup from './components/BookingPopup';
import CookieConsent from './components/CookieConsent';

function App() {
  const [showBookingPopup, setShowBookingPopup] = useState(false);

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/gallery/:category" element={<Gallery />} />
            <Route path="/appointment" element={<Appointment />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        
        {/* Floating Booking Widget */}
        <div className="fixed bottom-6 right-6 z-50">
          <button
            onClick={() => setShowBookingPopup(true)}
            className="bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 transition-all duration-300 hover:scale-105 animate-pulse"
          >
            <div className="flex items-center space-x-2">
              <span className="text-2xl">🩺</span>
              <div className="hidden sm:block">
                <div className="text-sm font-medium">Need to see a doctor?</div>
                <div className="text-xs opacity-90">Book appointment now</div>
              </div>
            </div>
          </button>
        </div>

        {/* Booking Popup */}
        <BookingPopup 
          isOpen={showBookingPopup} 
          onClose={() => setShowBookingPopup(false)} 
        />
        
        {/* Cookie Consent Banner */}
        <CookieConsent />
      </div>
    </LanguageProvider>
  );
}

export default App;